package nl.volleyplanner.web

import kotlinx.browser.window

@OptIn(ExperimentalJsExport::class)
@JsExport
object BuildConfig {
    val environment: String
        get() = js("ENVIRONMENT") as String

    val apiProtocol: String
        get() = js("API_PROTOCOL") as String

    val apiHost: String
        get() = (js("API_HOST") as String).let { if (it == "__HOSTNAME__") window.location.hostname else it }

    val apiPort: Int?
        get() = js("API_PORT") as Int?

    val apiPlannerHost: String
        get() = (js("API_PLANNER_HOST") as String).let { if (it == "__HOSTNAME__") window.location.hostname else it }

    val apiPlannerPort: Int?
        get() = js("API_PLANNER_PORT") as Int?
}